import {lazy} from "react";

export const ReportGroupActiveSessionsLazy = lazy(()=>import('./ReportGroupActiveSessions'))